import { toast } from "react-toastify";
import { apiURL } from "../../config";

export async function getCategoriesList(axiosPrivate, mineOnly = false) {
	return axiosPrivate
		.get(`${apiURL}/decision/category.json?mineOnly=${mineOnly}`)
		.then((res) => {
			if (res.status < 300 && res.status > 199) return res.data;
		})
		.catch((err) => {
			return err.response;
		});
}

export async function deleteCategory(axiosPrivate, cb, categoryId) {
	return axiosPrivate
		.delete(`${apiURL}/decision/category/${categoryId}.json`)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Category deleted");
				cb();
			} else {
				toast.error("Failed to delete category");
			}
		})
		.catch((err) => err.response);
}

export async function editCategory(axiosPrivate, cb, decisionCategoryId, data) {
	return axiosPrivate
		.put(`${apiURL}/decision/category/${decisionCategoryId}.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Category - updated");
				cb();
			} else {
				toast.error("Category failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}

export async function addCategory(axiosPrivate, cb, data) {
	return axiosPrivate
		.post(`${apiURL}/decision/category.json`, data)
		.then((res) => {
			if (res.status > 199 && res.status < 300) {
				toast.success("Category - updated");
				cb();
			} else {
				toast.error("Category failed to update");
			}
		})
		.catch((err) => {
			return err.response;
		});
}
